import { mapGetters, mapActions } from "vuex";
import { store } from "@checkout/store/store";
import api from "@checkout/services/api";
import router from "@checkout/router";
import localStorage from "@checkout/services/storage";
import storage from "@checkout/services/storage";
import citizenship from "@checkout/services/citizenship";
import Navigation from "@checkout/components/Partials/Navigation.vue";
import PaymentModal from "@checkout/components/Partials/PaymentModal.vue";
import SingleStep from "@checkout/components/Partials/SingleStep.vue";
import StepWrapper from "@checkout/components/Partials/StepWrapper.vue";
import stepsMixin from "@checkout/mixins/stepsMixin";
import _ from "lodash";
import moment from "moment";
import { EventBus } from '../../EventBus';
import { transformErrors } from '@checkout/services/errors';

export default {
  name: "CheckoutStep5",

  mixins: [stepsMixin],

  components: {
    Navigation,
    PaymentModal,
    SingleStep,
    StepWrapper,
  },

  data() {
    return {
      currentYear: new Date().getFullYear() - 18,
      agbChecked: 0,
      termsError: false,
      form: {
        isTv: false,
        typeOfBill: "email",
        terms: false,
        identifiedBy: "182400004",
        idNo: "",
        issueDate: "",
        validUntil: "",
        issuer: "",
        mobilePhone: "",
        citizenship: "",
      },
      form2: {
        document: "",
        token: "",
      },
      errors: {},
      salutationOverwrite: false,
      citizenships: citizenship.data.countries,
      isSelectChanged: false,
      postpaid: true,
      business: false,
      numberOfTerms: 0,
      terms: {
        agb: [],
        gdpr: [],
      },
      skipJumping: false,
      showPaymentModal: false,
      formActionUrl: "/checkout/6",
      srcScript: process.env.MIX_PAYUNITY_URL,
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters(["checkout", "steps", "isGeneralCheckout", "usePrepaidSteps"]),

    isStep5() {
      return this.$route.meta.stepNumber === "5";
    },

    getIdentifiedByKeys() {
      return citizenship.getIdentifiedByKeys(
        this.form.citizenship,
        this.postpaid
      );
    },
  },

  methods: {
    ...mapActions(["updatePostBill"]),

    handlePurchaseEvent() {
      this.saveCustomer();
    },

    prepareStep5() {
      api
        .get("/public-api/prepare/5/" + localStorage.get("page-step", true))
        .then((response) => {
          this.form = response.data.user;
          this.postpaid = response.data.postpaid;
          this.form.isTv = response.data.tv;
          this.business = response.data.business;
          this.numberOfTerms = response.data.agb.filter(
            (agb) => agb.required
          ).length;
          this.terms.agb = response.data.agb;
          this.terms.gdpr = response.data.gdpr;

          if (this.form.salutation.length === 0) {
            this.salutationOverwrite = true;
          }

          let token = localStorage.get("token", true);

          if (token !== null && typeof token !== "undefined") {
            this.form.token = token;
          }
        })
        .catch((error) => {
          this.$swal(this.$i18nApi.t("messages.error"));
          if (error.response.data.hasOwnProperty("page")) {
            storage.save("page-step", error.response.data.page, true);
            this.skipJumping = true;
            router.push("/checkout/" + error.response.data.page);
          } else {
            router.push("/checkout/1");
          }
        });
    },

    proceedToNextStep: function () {
      if (!this.form.terms) {
        this.termsError = true;
        return;
      }

      this.termsError = false;

      store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE");
      this.errors = {};
      
      this.form.username = this.form.email;
      this.form.country = "CH";

      if (this.business) {
        this.createOrder();
      } else {
        if (this.form.isTv) {
          this.form.ott_user = true;
        }

        api
          .post("/public-api/create-customer", this.form)
          .then((response) => {
            store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");

            if (response.data.body.hasOwnProperty("token")) {
              if (!this.form.hasOwnProperty("token")) {
                this.form.token = response.data.body.token;
              }
              localStorage.save("token", response.data.body.token, true);
            }

            if (this.form.isTv) {
              this.form2.token = response.data.body.token;
              this.uploadDocument();
            } else {
              if (!this.postpaid) {
                this.showPayment();
              } else {
                this.createOrder();
              }
            }
          })
          .catch((error) => {
            store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");
            this.$swal(this.$i18nApi.t("messages.error"));

            if (error.response.status === 422) {
              this.errors = transformErrors(error.response.data.errors);
            }

            if (error.response.data.hasOwnProperty("username")) {
              this.$swal({
                title: this.$i18nApi.t("userExists"),
                icon: "warning",
                button: this.$i18nApi.t("checkout4.titleLogin"),
              }).then(() => {
                router.push("/checkout/3");
              });
            }

            if (error.response.data.hasOwnProperty("bad-address")) {
              this.$swal(this.$i18nApi.t("badAddress"));
              let element = this.$refs["address"];
              let top = element.offsetTop;

              window.scrollTo(0, top);
            }
          });
      }
    },

    createOrder() {
      store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE");

      api
        .post("/public-api/create-order", { billPayed: false })
        .then(() => {
          store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");
          router.push("/checkout/7");
        })
        .catch((error) => {
          store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");

          this.$swal(this.$i18nApi.t("messages.error"));
        });
    },

    showPayment() {
      store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE");

      api
        .post("/public-api/prepare-transaction-request-js")
        .then((response) => {
          store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");
          window.location.href = response.data.redirectUrl;
        })
        .catch((error) => {
          store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");
          if (error.response.data.hasOwnProperty("amount")) {
            this.createOrder();
          } else {
            this.$swal(this.$i18nApi.t("messages.error"));
          }

          if (error.response.status === 422) {
            this.errors = transformErrors(error.response.data.errors);
          }
        });
    },

    /**
     * On change select input, then append darker font
     */
    appendClass() {
      this.isSelectChanged = true;
    },

    /**
     * Close payment modal
     */
    closeModal() {
      this.showPaymentModal = false;
    },


    uploadImage(e) {
      if (!e.target.files.length) {
        return;
      }

      this.form2.document = e.target.files[0];
    },

    uploadDocument() {
      let formData = new FormData();

      formData.append("token", this.form2.token);
      formData.append("document", this.form2.document);

      api
        .post("/public-api/upload-document", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .finally(() => {
          if (!this.postpaid) {
            this.showPayment();
          } else {
            this.createOrder();
          }
        });
    },
  },

  mounted() {
    EventBus.$on('purchaseEvent', this.handlePurchaseEvent);

    localStorage.save('page-step', '5', true);
    this.prepareStep5();

    this.$root.$on("agbChecked", (agbChecked) => {
      this.agbChecked = agbChecked;
    });
  },

  beforeDestroy() {
    EventBus.$off('purchaseEvent', this.handlePurchaseEvent);
  },

  beforeRouteLeave(to, from, next) {
    if (!this.skipJumping) {
      storage.save(
        "page-step",
        window.location.pathname.split("/").pop(),
        true
      );
    }
    next();
  },

  watch: {
    "form.typeOfBill": function () {
      if (this.form.typeOfBill === "post") {
        this.updatePostBill(true);
      } else {
        this.updatePostBill(false);
      }

      this.$root.$emit("reloadCheckout", true);
    },

    "form.terms": _.debounce(function () {
      this.$store.commit("SET_TERMS_ACCEPTED", this.form.terms);
    }, 500),
  },
};
